module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Draycott Everlasting")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "part",
    attrs: {
      "id": "opt02"
    }
  }, [_c('div', {
    staticClass: "partHead",
    attrs: {
      "id": "ph02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('h2', {
    staticClass: "partNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("PART TWO")])])]), _c('h2', {
    staticClass: "partTitle"
  }, [_vm._v("The Gift")]), _c('p', {
    staticClass: "partSubtitle"
  }, [_c('span', [_vm._v("Night cannot hold,"), _c('br'), _vm._v("\nNor forest gain…")])])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  })]), _c('div', {
    staticClass: "partBody"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page42"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d291da2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draycotteverlasting_opt02.vue
// module id = 84
// module chunks = 0